import { useQuery, useQueryClient } from "@tanstack/react-query";
import { apiCall, apiSend } from "../lib/api";
import type { TaskItem } from "../lib/types";

/** Open tasks for the tray (/api/tasks). */
export function useTasks(enabled: boolean) {
  return useQuery({
    queryKey: ["tasks"],
    queryFn: () => apiCall<TaskItem[]>("tasks"),
    enabled,
  });
}

export function taskActions(invalidate: () => void) {
  return {
    done: async (id: number) => {
      await apiSend(`tasks/${id}/done`, "POST");
      invalidate();
    },
    dismiss: async (id: number) => {
      await apiSend(`tasks/${id}/dismiss`, "POST");
      invalidate();
    },
    approve: async (id: number) => {
      await apiSend(`tasks/${id}/approve`, "POST");
      invalidate();
    },
    reject: async (id: number, reason: string) => {
      await apiSend(`tasks/${id}/reject`, "POST", { reason });
      invalidate();
    },
    editDraft: async (id: number, draft_text: string) => {
      await apiSend(`tasks/${id}/edit-draft`, "POST", { draft_text });
    },
  };
}

export function useTaskInvalidate() {
  const qc = useQueryClient();
  return () => {
    qc.invalidateQueries({ queryKey: ["tasks"] });
    qc.invalidateQueries({ queryKey: ["counts"] });
    qc.invalidateQueries({ queryKey: ["email-tasks"] });
  };
}

const STATUS_LABELS: Record<string, string> = {
  investigating: "Investigating",
  blocked: "Needs Input",
  "draft-ready": "Draft Ready",
  sent: "Sent",
  rejected: "Rejected",
};

/** getStatusPill() — returns label + class, or null when no pill. */
export function statusPill(task: TaskItem): { label: string; cls: string } | null {
  if (!task.status || task.status === "pending") return null;
  return { label: STATUS_LABELS[task.status] || task.status, cls: task.status };
}
